import React from 'react';
import { useSelector } from 'react-redux';
import AlbumDetailComponent from '../components/albumDetail';
import * as action from '../redux/actions';

const AlbumDetailPageContainer = () => {
  return <AlbumDetailComponent 
    deleteAlbum={action.deleteAlbumRequest}
  />;
};


export default AlbumDetailPageContainer;
